<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
        @click:row="selectRow"
        :footer-props="globalFooterOptions"
        :headers="headers"
        :items="items"
        :items-per-page="globalItemsPerPage"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        style="margin-bottom: 80px;"
        >
          <template v-slot:item.timeCreated="{ item }" >{{ formatDateTime(item.timeCreated) }}</template>
          <template v-slot:item.timeModified="{ item }" >{{ formatDateTime(item.timeModified) }}</template>
          <template v-slot:item.actions="{ item }" style="width: 1px;">
            <v-btn @click.stop="deleteItem(item)" icon><v-icon>delete</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>

</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      errorText: '',
      headers: [
        { text: 'Tags', value: 'tags' },
        { text: 'Annotation', value: 'annotation' },
        { text: 'Created', value: 'timeCreated' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      items: [],
      loading: false,
      options: {},
      totalItems: 0
    }
  },

  created () {
    this.getData()
  },

  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },

  methods: {
    getData: function () {
      if (this.options.page !== undefined) {
        this.loading = true

        var params = {}
        if (this.options.itemsPerPage > 0) {
          params.page = (this.options.page - 1) * this.options.itemsPerPage
          params.limit = this.options.itemsPerPage
        }

        if (this.options.sortBy.length > 0) {
          params.sort = ''
          if (this.options.sortDesc[0]) {
            params.sort = '-'
          }
          params.sort = params.sort + this.options.sortBy[0]
        }

        ApiRequests.logQuery(params).then(r => {
          this.items = r.data
          this.totalItems = parseInt(r.headers['x-total-count'])
          this.loading = false
        })
      }
    },

    deleteItem: function (item) {
      ApiRequests.logDelete(item.id).then(r => {
        this.getData()
      }).catch(e => {
        this.errorText = 'Error deleting log: ' + e.response.data
        console.log(e)
      })
    },

    selectRow: function (item) {
      this.$router.push({ name: 'logView', params: { id: item.id } })
    }
  }
}
</script>
